import '/assets/js/common.js';
import '/assets/css/common.scss';
import '/assets/css/single-news.scss';